/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, ReactElement, useMemo } from 'react'
import Decimal from '../decimal'
import SelectInput from '../selectInput'
import { Container } from './styles'

type ExamWithUnitAndResultInputProps = {
  result?: number;
  unitSelected?: string;
  name: string;
  unities: string[];
  onChange?: (e: any) => void;
  onSelect?: (e: any) => void;
}

const ExamWithUnitAndResultInput: FC<ExamWithUnitAndResultInputProps> = ({
  name,
  result,
  unities,
  unitSelected,
  onChange,
  onSelect
}): ReactElement => {
  const unitiesSelector = useMemo(() => {
    return unities.map(u => ({ value: u, label: u }))
  }, [unities])

  const selectedUnity = useMemo(() => {
    return unitSelected ? { value: unitSelected, label: unitSelected } : undefined
  }, [unitSelected])

  return (
    <Container>
      <div className='exam_name' title={name}>
        Exame
        <div className='exam_name_label'>{name}</div>
      </div>
      <div className='exam_result'>
        <Decimal
          value={String(result || 0)}
          size='sm'
          label={'Resultado (Número)' + (result ? '*' : '')}
          onChange={onChange}
        />
      </div>
      <div className='exam_unit'>
        <SelectInput
          onChange={onSelect}
          options={unitiesSelector}
          value={selectedUnity}
          size='sm'
          label={'Unidade (Ex: ng/dl)' + (result ? '*' : '')}
        />
      </div>
    </Container>
  )
}

export default ExamWithUnitAndResultInput
